import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const GetOtuProcessingDataEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.fetchOtuProcessingData.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return OrderRepository.getOtuProcessingData(action.payload.orderId).pipe(
        mergeMap((response) => of(order.fetchOtuProcessingDataResult({ result: response }))),
        catchError((error: Error) => {
          console.warn('error fetching OTU processing data, this may just indicate it is not there yet', error)
          return of(order.fetchOtuProcessingDataResult({ result: null }))
        })
      )
    })
  )
